// src/components/files/FolderPath.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Button } from 'react-bootstrap';

const FolderPath = ({ currentPath, navigateToFolder, navigateUp }) => {
  return (
    <div className="folder-path-container d-flex flex-column mb-2 p-2">
      <div className="d-flex align-items-center flex-wrap">
        {/* Only show back button when user is in a folder */}
        {currentPath.length > 0 && (
          <Button 
            variant="outline-secondary" 
            size="sm" 
            className="back-btn me-2 mb-1"
            onClick={navigateUp}
            style={{ width: 'auto', minWidth: '80px', maxWidth: '100px' }}
          >
            <i className="fas fa-arrow-left me-1"></i>
            Back
          </Button>
        )}
        
        <Breadcrumb className="flex-grow-1 mb-0 breadcrumb-container">
          <Breadcrumb.Item 
            onClick={() => navigateToFolder('')}
            active={currentPath.length === 0}
            className="folder-breadcrumb-item"
          >
            All Files
          </Breadcrumb.Item>
          
          {currentPath.map((folder, index) => {
            const pathToHere = currentPath.slice(0, index + 1).join('/');
            
            return (
              <Breadcrumb.Item
                key={`breadcrumb-${index}-${folder}`}
                onClick={() => index < currentPath.length - 1 ? navigateToFolder(pathToHere) : null}
                active={index === currentPath.length - 1}
                className="folder-breadcrumb-item"
              >
                {folder}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      </div>
    </div>
  );
};

FolderPath.propTypes = {
  currentPath: PropTypes.array.isRequired,
  navigateToFolder: PropTypes.func.isRequired,
  navigateUp: PropTypes.func.isRequired
};

export default FolderPath;